import * as d3 from "d3";
import { format } from "date-fns";
import { isNil } from "lodash";
import { formatPhoneNumberIntl } from "react-phone-number-input";
const locale = d3.formatLocale({
    decimal: ".",
    thousands: " ",
    grouping: [3],
    currency: ["", ""],
});
export const formatNumber = (value, round = true, precision) => {
    if (isNil(value)) {
        return "";
    }
    return locale.format(`,.${precision ?? 2}~f`)(round ? Math.round(+value) : +value);
};
export const formatDate = (date) => {
    if (isNil(date)) {
        return "";
    }
    return format(date, "dd.MM.yyyy");
};
export const getDateObject = (date) => {
    if (isNil(date)) {
        return;
    }
    const paramDate = +date.split(".")?.[0];
    const paramMonth = +date.split(".")?.[1];
    const paramYear = +date.split(".")?.[2];
    return new Date(paramYear, paramMonth - 1, paramDate);
};
export const hex2rgb = (hex) => {
    if (isNil(hex)) {
        return { r: 0, g: 0, b: 0 };
    }
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    return { r, g, b };
};
export const simplifyPhone = (p) => {
    if (isNil(p) || (typeof p === "string" && p.length === 0)) {
        return null;
    }
    const cleanPhone = p.replace(/[-\s()]/g, "");
    return !cleanPhone.startsWith("+") ? `+${cleanPhone}` : cleanPhone;
};
export const formatPhone = (phone) => {
    if (isNil(phone) || phone.length === 0) {
        return null;
    }
    const cleanPhone = simplifyPhone(phone);
    if (cleanPhone.startsWith("+7")) {
        let result = cleanPhone.slice(2);
        if (result.length === 10) {
            result = `${result.slice(0, 3)} ${result.slice(3).slice(0, 3)}-${result.slice(6).slice(0, 2)}-${result.slice(8)}`;
            return `+7 ${result}`;
        }
        return formatPhoneNumberIntl(cleanPhone);
    }
    return formatPhoneNumberIntl(cleanPhone);
};
